export const PRICE_MAX = 299999
